import { Link } from "react-router-dom";
import { Facebook, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { HOURS, OCCASIONS, SITE, TOWNS } from "../data/site";

const EXPLORE = [
  { label: "Sympathy & Funeral", href: "/sympathy-funeral-flowers" },
  { label: "Holidays & Seasonal", href: "/seasonal" },
  { label: "Prom Corsages", href: "/prom-corsages-boutonnieres" },
  { label: "Business Flowers", href: "/business-flowers" },
  { label: "Gallery", href: "/gallery" },
  { label: "Our Story", href: "/about" },
  { label: "Journal", href: "/journal" },
  { label: "Contact & Order", href: "/contact" },
  { label: "FAQ", href: "/faq" },
  { label: "Policies", href: "/policies" },
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-plum pb-24 text-ivory md:pb-0">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <span className="inline-flex items-center rounded-xl border border-gold/50 bg-ivory px-5 py-3 shadow-lg shadow-black/20">
              <Logo variant="full" className="h-14 w-auto" />
            </span>
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-ivory/75">
              Family owned and operated on Main Street since {SITE.founded}. Every arrangement designed in the shop,
              hand-delivered by our own driver.
            </p>
            <a
              href={SITE.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-ivory/85 transition-colors hover:text-gold"
            >
              <Facebook className="h-4 w-4" aria-hidden="true" />
              Follow us on Facebook
            </a>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-eyebrow text-gold">Visit the Shop</h3>
            <address className="mt-5 text-[15px] not-italic leading-relaxed text-ivory/85">
              <a
                href={SITE.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-directions-link"
                className="flex items-start gap-2 transition-colors hover:text-gold"
              >
                <MapPin className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                {SITE.address}
              </a>
              <a
                href={SITE.phoneHref}
                data-testid="footer-phone-link"
                className="mt-3 flex items-center gap-2 font-bold text-ivory transition-colors hover:text-gold"
              >
                <Phone className="h-4 w-4 text-gold" aria-hidden="true" />
                {SITE.phone}
              </a>
            </address>
            <ul className="mt-4 space-y-1 text-[14px] text-ivory/70">
              {HOURS.map((h) => (
                <li key={h.days} className="flex justify-between gap-4">
                  <span>{h.days}</span>
                  <span>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <nav aria-label="Occasions and delivery">
            <h3 className="text-xs font-bold uppercase tracking-eyebrow text-gold">Occasions & Delivery</h3>
            <ul className="mt-5 space-y-2 text-[15px]">
              {OCCASIONS.map((o) => (
                <li key={o.path}>
                  <Link to={o.path} className="text-ivory/75 transition-colors hover:text-gold">
                    {o.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/flower-delivery" className="font-bold text-ivory/85 transition-colors hover:text-gold">
                  Flower Delivery
                </Link>
              </li>
              {TOWNS.map((t) => (
                <li key={t.path}>
                  <Link to={t.path} className="text-ivory/75 transition-colors hover:text-gold">
                    {t.name}, RI
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Explore">
            <h3 className="text-xs font-bold uppercase tracking-eyebrow text-gold">Explore</h3>
            <ul className="mt-5 space-y-2 text-[15px]">
              {EXPLORE.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-ivory/75 transition-colors hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="gold-rule mt-14 opacity-50" aria-hidden="true" />
        <div className="mt-6 flex flex-col items-center justify-between gap-3 text-[13px] text-ivory/55 sm:flex-row">
          <p>© {new Date().getFullYear()} JIF – Jack Iannotti Flowers · Coventry, Rhode Island</p>
          <p className="uppercase tracking-[0.2em]">Family owned & operated since {SITE.founded}</p>
        </div>
      </div>
    </footer>
  );
}
